import { useQuery } from '@tanstack/react-query';

import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useSessionFeedback(sessionId: string | undefined) {
  return useQuery({
    queryKey: sessionsKeys.operation('feedback', sessionId ?? ''),
    queryFn: () => {
      if (!sessionId) throw new Error('missing id');
      return sessionsService.listFeedback(sessionId);
    },
    enabled: Boolean(sessionId),
  });
}
